import { FC } from 'react'
import styled from 'styled-components'
import SelectedFilterList from '@app.feature/activityFilter/components/SelectedFilterList'
import { useSelectedFilter } from './BottomSelectedFilterList.module'

interface IFBottomSelectedFilterListProps {
  className?: string
}

const BottomSelectedFilterList: FC<IFBottomSelectedFilterListProps> = ({
  className,
}) => {
  const { isEmpty, selectedFilterList, onRemove, onReset } = useSelectedFilter()

  if (isEmpty) {
    return null
  }

  return (
    <StyledSelectedFilterList
      className={className}
      items={selectedFilterList}
      onRemove={onRemove}
      onReset={onReset}
    />
  )
}

export default BottomSelectedFilterList

const StyledSelectedFilterList = styled(SelectedFilterList)``
